<template>
	<div ref="container" style="padding: 0 0px;height: 100%;">
		<div style="padding: 0 24px;">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane :label="$t('baoyangfenzu')" name="first">
					<!-- <group_table></group_table>	 -->
				</el-tab-pane>
				<el-tab-pane :label="$t('mingxishuju')" name="second">
					<!-- <standard_table></standard_table> -->
				</el-tab-pane>
			</el-tabs>
		</div>

		<div :style="{'height':tableHeight+'px'}">
			<group_table v-show="activeName=='first'" v-if="tableHeight!=0"></group_table>
			<standard_table v-show="activeName=='second'" v-if="tableHeight!=0"></standard_table>
		</div>
	</div>
</template>

<script>
	import standard_table from '@@/pages/web/base/maintain_standard/standard_list.vue'
	import group_table from '@@/pages/web/base/maintain_standard/group_list'
	export default {
		name: 'web_base_maintain_standard_index',
		components: {
			group_table,
			standard_table,
		},
		data() {
			return {
				activeName: 'first',
				tableHeight: 0,
			}

		},
		created() {

		},

		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		methods: {
			resize() {
				this.$nextTick(() => {
					this.tableHeight = this.$refs.container.offsetHeight - 40 - 15
				})
			},
			handleClick(tab) {
				this.utils.event_hub.$emit('RESIZE')



			}
		}
	}
</script>

<style>
</style>
